import React from 'react'
import { Link } from 'react-router-dom';
import { Link as ScrollTo } from 'react-scroll';
import { Element } from 'react-scroll';

const AURAAgenticAIBanner = () => {

  return (
    <Element
      name="AURAAgenticAIBanner"
      className="aura-ai-banner banner-style-1 height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-7 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center color-body2">
                  <Link className="color-body2" to="/">Home</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  AURA Agentic AI
                </div>
                <h1 className="datatalent-program-title color-white title mt-5 mt-md-4"><span className="product-banner-title">AURA</span> - Agentic AI</h1>
                <p className="product-description mt-5 mt-md-0">The Next Evolution: Pre-Built Smart Agents for Industry</p>
                <p className="color-body2">AURA is M2M's modular Agentic AI suite, empowering organizations to automate complex tasks at the edge and seamlessly connect with the cloud. Harness domain-specific agents designed for reliability, adaptability, and scalability.</p>
                <div className="read-more-btn banner-btns">
                  <ScrollTo
                    className="edu-btn btn-secondary text-center"
                    to="WhatIsAgenticAI"
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    Know More<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </ScrollTo>
                  <Link className="edu-btn btn-primary text-center" to="/contact-us">
                    Request Demo<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-5 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <img src={`${process.env.PUBLIC_URL}/images/products/aura_agentic.png`} alt="Agentic AURA AI" loading="lazy" />
          </div>
        </div>
      </div>
    </Element>
  )
}

export default AURAAgenticAIBanner;